import type React from 'react';
import { MenuItem } from './common';

const MenuLink: React.FC<{ href: string; children?: React.ReactNode }> = ({ href, children }) => (
  <MenuItem>
    <a href={href}>{children}</a>
  </MenuItem>
);

export default MenuLink;
